<template>
  <div>
    <carousel :perPage="1">

      <slide>
        <div class="padding">
          <p>Oska asked me . . I don't know how to write this, my head is still aching from just thinking about it, Oska asked me where dad was, and when he was coming back . .</p>
        </div>
      </slide>

      <slide>
        <div class="padding">
          <p>and I didn't know</p>
        </div>
      </slide>

      <slide>
        <div class="padding">
          <p>but i couldn't say that, and really it's not correct; it's more like . . .</p>
        </div>
      </slide>

      <slide>
        <div class="padding">
          <p>I can't remember</p>
        </div>
      </slide>

      <slide>
        <div class="padding">
          <p>and it made me think about these words</p>
        </div>
      </slide>

      <slide>
        <div class="padding">
          <p>and why i'm writing them,</p>
        </div>
      </slide>

      <slide>
        <div class="padding">
          <p>and where you are,</p>
        </div>
      </slide>

      <slide>
        <div class="padding">
          <p>and who you are,</p>
        </div>
      </slide>

      <slide>
        <div class="padding">
          <p>and if you would carry me out of the water?</p>

        </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '2',

  data () {
    return {
      title: 'An Answer'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
